import axios from "axios";
import { apiActiveURL, appId, appKey } from "../../ApiBaseURL";

export const GetSpecialPromotions = () => {
  const SessionData = JSON.parse(localStorage.getItem("SessionData"));

  var config = {
    url: `${apiActiveURL}/promotions/${SessionData[1]}`,

    method: "GET",
    headers: {
      AppKey: appKey,
      Token: SessionData[0],
      AppId: appId,
    },
  };

  return (dispatch) => {
    axios(config)
      .then((res) => {
        // console.log(res, "get special promotions response =======");
        if (res.data.status) {
          GetSpecialPromotionsSuccess(dispatch, res);
        } else {
          GetSpecialPromotionsFail(dispatch, res.data.message);
        }
      })
      .catch((e) => {
        GetSpecialPromotionsFail(dispatch, e.message);
      });
  };
};

export const ResetGetSpecialPromotions = () => {
  return (dispatch) => {
    dispatch({ type: "GET_SPECIAL_PROMOTIONS_SUCCESS", payload: null });
  };
};

export const ResetGetSpecialPromotionsError = () => {
  return (dispatch) => {
    dispatch({ type: "GET_SPECIAL_PROMOTIONS_FAIL", payload: null });
  };
};

const GetSpecialPromotionsSuccess = (dispatch, res) => {
  dispatch({ type: "GET_SPECIAL_PROMOTIONS_SUCCESS", payload: res });
};

const GetSpecialPromotionsFail = (dispatch, res) => {
  dispatch({ type: "GET_SPECIAL_PROMOTIONS_FAIL", payload: res });
};
